export default function ServiceCompanies() {
	const target = document.querySelector('.js-service-submit');
	const error = document.querySelector('.js-service-error');

	if (target) {

		// TODO: add multilingual support

		target.addEventListener('click', async (e) => {
			e.preventDefault();

			const country = e.target.dataset.country;
			const value = e.target.dataset.postcode
			const token = e.target.dataset.token;
			let translations = e.target.dataset.translations;

			if (translations) {
				translations = JSON.parse(atob(translations));
			}

			e.target.textContent = translations.searching;

			setTimeout(() => {
				if (value === '' || country === '') {
					e.target.textContent = translations.submit;
					error.textContent = translations.error;
					error.classList.remove('!hidden');

					setTimeout(() => {
						error.classList.add('!hidden');
					},4000)

					return;
				}

				fetch('/my-true/service-companies', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-CSRF-TOKEN': token
					},
					body: JSON.stringify({
						country: country,
						postcode: value
					})
				})
					.then(response => response.json())
					.then(data => {
						if (data.error) {
							e.target.textContent = translations.submit;
							error.textContent = data.error;
							error.classList.remove('!hidden');

							setTimeout(() => {
								error.classList.add('!hidden');
							}, 4000)

						} else {
							const companies = data
							let count = data.length;

							const results = document.querySelector('.js-service-results');

							results.innerHTML = '';

							const header = document.createElement('div');
							header.classList.add('grid', 'grid-cols-3', 'gap-2.5', 'bg-black', 'text-white', 'p-2', 'rounded-t', 'min-w-[600px]');
							header.innerHTML = `
								<div class="text-white text-sm font-bold">${translations.company}</div>
								<div class="text-white text-sm font-bold">${translations.phone}</div>
								<div class="text-white text-sm font-bold">${translations.email}</div>
							`;

							results.appendChild(header);

							companies.forEach((company, index) => {
								const div = document.createElement('div');
								div.classList.add('grid', 'grid-cols-3', 'gap-2.5', 'bg-white', 'p-2', 'border-t', 'border-x', 'border-gray-200', 'min-w-[600px]');

								if (index === count - 1) {
									div.classList.add('rounded-b', 'border-b');
								}

								div.innerHTML = `
									<div class="text-sm">${company.company_name ? company.company_name : ''}</div>
									<a href="tel:${company.company_phone_number ? company.company_phone_number : ''}" class="text-primary text-sm hover:text-secondary transition-colors">${company.company_phone_number ? company.company_phone_number : ''}</a>
									<a href="mailto:${company.company_email_address ? company.company_email_address : ''}" class="text-primary text-sm hover:text-secondary transition-colors">${company.company_email_address ? company.company_email_address : ''}</a>
								`;
								results.appendChild(div);
							});

							e.target.textContent = translations.submit;
							results.classList.remove('hidden');

						}
					});
			}, 500);


		});
	}
}
